import actions from './auth.actions';
import mutations from './auth.mutations';

export default {
  actions,
  mutations,
  state: null
};
